import type * as FAQModule from '../types/FAQModule'

export default function faqModuleComponentParser(
  rawComponent: FAQModule.Raw,
): FAQModule.Parsed {
  const props = rawComponent.faqModule

  return {
    name: 'FAQModule',
    props,
  }
}
